export { DocFooter } from './DocFooter';
